import makeSettingsReducer from 'app/common/reducers/settings/makeSettingsReducer';

import config from 'app/config';


const orgsMenuEditDefaultState = {
  rows: config.perPageItems,
  selectable: true,
  title: true,
  photo: true,
  portion: true,
  cost: true,
};

export default makeSettingsReducer('orgsMenuEdit', orgsMenuEditDefaultState);
